/* eslint-disable no-console, no-unused-vars */
import { COMMENT_SERVICE } from '../constants'

const COMMENTS = "/comments"
const CHANNELS = "/channels"

const state = {
}

const mutations = {
}

const actions = {
  fetchComments ({ commit, dispatch }, target) {
    return new Promise(function (resolve, reject) {
      dispatch('API', COMMENT_SERVICE, { root: true })
        .then(api => api.get(COMMENTS + '?target=' + encodeURIComponent(target)))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  addComment ({ commit, dispatch }, comment) {
    return new Promise(function (resolve, reject) {
      dispatch('API', COMMENT_SERVICE, { root: true })
          .then(api => api.post(COMMENTS, comment))
          .then(response => resolve(response.data))
          .catch(err => reject(err))
    })
  },
  updateComment ({ commit, dispatch }, comment) {
    return new Promise(function (resolve, reject) {
      dispatch('API', COMMENT_SERVICE, { root: true })
          .then(api => api.put(COMMENTS + '/' + encodeURIComponent(comment.id), comment))
          .then(response => resolve(response.data))
          .catch(err => reject(err))
    })
  },
  deleteComment ({ commit, dispatch }, { id }) {
    return new Promise(function (resolve, reject) {
      dispatch('API', COMMENT_SERVICE, { root: true })
          .then(api => api.delete(COMMENTS + '/' + encodeURIComponent(id)))
          .then(response => resolve(response.data))
          .catch(err => reject(err))
    })
  },
}

const getters = {
}

export default { namespaced: true, actions, getters, mutations, state }
